<template>
  <v-row style="overflow: auto; position: relative">
    <Loading v-if="isLoading"/>
    <template v-if="settingList.length > 0">
      <v-col md="3" lg="3">
      </v-col>
      <v-col md="9" lg="9">
        <v-row>
          <v-col cols="12" class="py-0">
            <h2 class="step_title primary--text font-weight-light mr-3 text-uppercase">PRIX BASIC DU CONTACT PAR NIVEAU</h2>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="3" lg="3"
         class="user-block px-8 pb-6"
         :class="{'setting-tab-2-column-1': indexCol === 0}"
         v-for="(col, indexCol) in column" :key="indexCol"
         style="border-top: none"
      >
        <v-card flat ref="form" class="mt-0 px-0">
          <v-card-text class="pa-0" >
            <v-row>
              <template  v-for="(num, indexNum) in col">
                <template v-for="(item, indexItem) in settingList">
                  <v-col cols="12" class="py-0" :key="`${indexItem}_${indexNum}`" v-if="item.id === num">
                    <ValidationObserver :ref="`form_${item.id}`" v-slot="{ validate, reset }">
                      <v-form @submit.prevent="updateSetting(item)">
                        <v-row md="12" class="label-setting">
                          <v-col cols="10" class="label">{{ item.name }}</v-col>
                          <v-col cols="2" @click="edited = item.id" v-if="edited !== item.id">
                            <v-icon x-small>fas fa-edit</v-icon>
                          </v-col>
                          <v-col cols="2" v-else @click="updateSetting(item)">
                            <v-icon x-small>fas fa-save</v-icon>
                          </v-col>
                        </v-row>
                        <ValidationProvider :name="item.name" rules="required" v-slot="{ errors }">
                          <v-text-field
                            hide-details="auto"
                            v-model="item.value"
                            outlined
                            append-icon="$euro_sign"
                            required
                            type="number"
                            :error-messages="errors"
                            @keypress="isNumber($event)"
                            :disabled="edited !== item.id"
                          />
                        </ValidationProvider>
                      </v-form>
                    </ValidationObserver>
                  </v-col>
                </template>
              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>


<script>
import SettingService from "../../services/setting.service";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import Loading from '../../components/Loading.vue';
export default {
  name: "UserTariffManagement",
  components: {
    ValidationObserver,
    ValidationProvider,
    Loading
  },
  data() {
    return {
      settingList: [],
      isLoading: false,
      edited: null,
      column: [
        [1,2,3,4,5,6,7,8],
        [9,10,11,12,13,14],
        [15,16,17,18,19],
        [20,21],
      ]
    };
  },
  created() {
    this.getSetting();
  },
  methods: {
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async getSetting() {
      this.isLoading = true;
      const data = await SettingService.getList();
      if(data) {
        this.settingList = data.data;
      }
      this.isLoading = false;
    },
    async updateSetting(item) {
      let validate = this.$refs['form_' + item.id];
      let error = await validate[0].validate();
      if(error) {
        this.isLoading = true;
        let req = await SettingService.update(item);
        if(req) {
          await validate[0].reset();
          this.edited = null;
        }
      }
      this.isLoading = false;
    }
  }
};
</script>

<style>

</style>
